var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.912 19.495a1 1 0 1 0-1.414-1.414l1.414 1.414zm4.243-7.07a1 1 0 0 0 1.414 1.413l-1.414-1.414zm-7.071-7.072a1 1 0 0 0 1.414 1.414l-1.414-1.414zM6.84 12.424a1 1 0 0 0-1.414-1.414l1.414 1.414zm2.122 2.122a1 1 0 1 0 1.414 1.414l-1.414-1.414zm7.07-4.243a1 1 0 1 0-1.414-1.414l1.415 1.414zm-3.535 7.778a4 4 0 0 1-5.657 0l-1.414 1.414a6 6 0 0 0 8.485 0l-1.414-1.414zm5.657-11.314a4 4 0 0 1 0 5.657l1.414 1.415a6 6 0 0 0 0-8.486l-1.414 1.414zm-5.657 0a4 4 0 0 1 5.657 0l1.414-1.414a6 6 0 0 0-8.485 0l1.414 1.414zm-7.07 4.243a6 6 0 0 0 0 8.485l1.413-1.414a4 4 0 0 1 0-5.657L5.427 11.01zm4.949 4.95 5.657-5.657-1.415-1.414-5.656 5.657 1.414 1.414z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.d2ee1b26789cc564da21dd2428cea2c8.svg";
export { ForwardRef as ReactComponent };